import { createSelector } from 'reselect';

const alertState = state => state.alert;

export const getSuccessMsg = createSelector(
    alertState,
    alert => alert.success
);

export const getErrorMsg = createSelector(
    alertState,
    alert => alert.error
);

export const getWarningMsg = createSelector(
    alertState,
    alert => alert.warning
);

export const getInfoMsg = createSelector(
    alertState,
    alert => alert.info
);